/**
 * Returns true if the given timeframe overlaps the other provided timeframe at any point.
 */
export function isOverlapping(timeframe1, timeframe2) {
    return includes(timeframe1, timeframe2.start) || includes(timeframe2, timeframe1.start);
}
/**
 * Returns true if the provided timeframe includes the given time at any point.
 *
 * This is inclusive of this timeframes start, but not of its end.
 */
export function includes(timeframe, localTime) {
    return localTime.compareTo(timeframe.start) >= 0 && localTime.compareTo(timeframe.end) < 0;
}
/**
 * Returns whether timeframe 1 is within (inclusive) timeframe 2.
 */
export function isWithin(timeframe1, timeframe2) {
    const startWithin = isSameOrAfter(timeframe1.start, timeframe2.start);
    const endWithin = isSameOrBefore(timeframe1.end, timeframe2.end);
    return startWithin && endWithin;
}
export function isSameOrAfter(time1, time2) {
    return time1.equals(time2) || time1.isAfter(time2);
}
export function isSameOrBefore(time1, time2) {
    return time1.equals(time2) || time1.isBefore(time2);
}
/**
 * Check if a list of given timeframes are within another given timeframe.
 */
export function areAllWithin(timeframe, timeframesToCheck) {
    return timeframesToCheck.every(timeframeToCheck => isWithin(timeframeToCheck, timeframe));
}
/**
 * Check that a given list of timeframes does not include any overlapping timeframes.
 * This first sorts the provided timeframe list by start time, and then loops through comparing each timeframe with the timeframe that comes after it.
 * Will return early if it finds an overlapping timeframe.
 */
export function hasOverlappingTimeframes(timeframes) {
    const sortedTimeframes = timeframes.sort((a, b) => a.start.toNanoOfDay() - b.start.toNanoOfDay());
    return sortedTimeframes.some((timeframe, index) => {
        if (index + 1 === timeframes.length) {
            return false;
        }
        return isOverlapping(timeframe, sortedTimeframes[index + 1]);
    });
}
